module.exports = __webpack_public_path__ + "img/company-dashboard.cd7c1cc2.svg";